import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import styled from 'styled-components';
import { useStore } from 'zustand';

import {
  IconRegularChevronLeft,
  InteractiveArea,
  theme,
} from '@notino/react-styleguide';

import { Hidden, Visible } from '@components/Hidden';
import { elipsis } from '@styles/common';

import { useListMenuContext } from './context';
import messages from './messages';

const Wrapper = styled.div`
  ${theme.typography.labelLarge}
  ${elipsis}
  display: flex;
`;

const ListName = styled.div`
  ${elipsis}
  margin-left: 20px;
`;

export const Header = () => {
  const { store } = useListMenuContext();
  const { list, currentAction } = useStore(store);

  const backButton =
    currentAction !== 'rootMenu' ? (
      <InteractiveArea
        size="40px"
        onClick={() => store.setState({ currentAction: 'rootMenu' })}
      >
        <div style={{ width: 52, display: 'flex', justifyContent: 'center' }}>
          <IconRegularChevronLeft width="20px" height="20px" />
        </div>
      </InteractiveArea>
    ) : null;

  return (
    <>
      {/* centers header text on mobile */}
      <Hidden breakpoint="md" style={{ width: 52 }}>
        {backButton}
      </Hidden>

      <Wrapper>
        {backButton && <Visible breakpoint="md">{backButton}</Visible>}

        {currentAction === 'rootMenu' && (
          <ListName>
            <FormattedMessage
              {...messages.drawerTitle}
              values={{ listName: list.name }}
            />
          </ListName>
        )}
        {currentAction === 'rename' && (
          <FormattedMessage {...messages.renameList} />
        )}
        {currentAction === 'delete' && (
          <FormattedMessage {...messages.deleteDrawerTitle} />
        )}
        {currentAction === 'share' && <FormattedMessage {...messages.share} />}
        {currentAction === 'addToCart' && (
          <>
            <FormattedMessage {...messages.addAllToCard} />?
          </>
        )}
      </Wrapper>
    </>
  );
};
